import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FIREBASE_EVENTS } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { Card, ContextLoader } from 'components'
import { setStage } from 'slices/drawer'
import { STATICS } from 'statics'
import { shouldRenderWifiInfo } from 'utils'
import { STAGES } from '../../constants'
import './style.scss'

export function ModemInfo() {
  const {
    internet,
    selected: { id: idContract, contractStatus },
  } = useSelector(({ contract }) => contract)
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()
  const [renderWifiInfo, setRenderWifiInfo] = useState(false)

  useEffect(() => {
    function handleInternet() {
      if (internet.hasConfigurationInProgress) {
        dispatch(setStage(STAGES.IN_PROGRESS))
      } else if (shouldRenderWifiInfo(contractStatus)) {
        setRenderWifiInfo(true)
        sendEvent(FIREBASE_EVENTS.WIFI_INFO)
      } else {
        sendEvent(FIREBASE_EVENTS.WIFI_INFO_EMPTY)
      }
    }

    if (internet) handleInternet()
  }, [contractStatus, dispatch, idContract, internet, sendEvent])

  function handleEditInternet() {
    dispatch(setStage(STAGES.EDIT))
  }

  function renderContractWithoutWifiInfo() {
    return <p className='empty'>Contrato selecionado não possui dados de WIFI.</p>
  }

  function renderContractWifiInfo() {
    return (
      <Card className='modemcard'>
        <p className='text'>
          <b>Rede: </b>
          {internet.ssid}
        </p>
        <p className='text'>
          <b>Senha: </b>
          {internet.wifiPassword}
        </p>
        <p className='text'>
          <b>Contrato: </b>
          {idContract}
        </p>
        <div className='icon' onClick={handleEditInternet}>
          <STATICS.EDIT />
        </div>
      </Card>
    )
  }

  function renderContent() {
    return (
      <div className='modem-info'>
        <h3 className='title'>Meu WIFI</h3>
        {renderWifiInfo ? renderContractWifiInfo() : renderContractWithoutWifiInfo()}
      </div>
    )
  }

  return internet ? renderContent() : <ContextLoader fixed={false} />
}
